export const FETCH_SOFTWARE_GAMES_REQUEST = "FETCH_SOFTWARE_GAMES_REQUEST";
export const FETCH_SOFTWARE_GAMES_SUCCESS = "FETCH_SOFTWARE_GAMES_SUCCESS";
export const FETCH_SOFTWARE_GAMES_FAILURE = "FETCH_SOFTWARE_GAMES_FAILURE";
export const FETCH_SOFTWARE_GAMES_DETAILS = "FETCH_SOFTWARE_GAMES_DETAILS";
export const FETCH_SOFTWARE_GAMES_TERMS = "FETCH_SOFTWARE_GAMES_TERMS";
export const FETCH_SOFTWARE_GAMES_IMAGES = "FETCH_SOFTWARE_GAMES_IMAGES";
export const FETCH_SOFTWARE_GAMES_DETAILS_SUCCESS = "FETCH_SOFTWARE_GAMES_DETAILS_SUCCESS";
export const FETCH_IMAGES_REQUEST = 'FETCH_IMAGES_REQUEST'
export const FETCH_IMAGES_FAILURE = 'FETCH_IMAGES_FAILURE'